<template>
    <v-container fluid class="bg-grey-darken-4 py-5">
        <v-container v-if="hasSettings" :key="hasSettings">
            <v-row v-if=" prefooter[locale]" :key="locale">
                <v-col>
                    <h3>{{ prefooter[locale].name }}</h3>
                    <p>{{ prefooter[locale].description }}</p>
                </v-col>
                <v-col cols="12">
                    <v-row no-gutters>
                        <v-col cols="12" md="4" class="mb-4" v-for="group in prefooter[locale].value" :key="group.title">

                            <h4 class="mb-2">{{ group.title }}</h4>
                        
                                <v-btn 
                                    v-for="link in group.group"
                                    :key="link.id+'-'+link.title" 
                                    :title="link.title" 
                                    variant="plain"
                                    class="text-start w-100 text-white btn-primelinks h-auto justify-content-start" 
                                    :to="link.route" >
                                    {{link.text}}
                                </v-btn>
                            
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed:{
        ...mapGetters({
            hasSettings: 'settings/hasSettings',
            prefooter: 'settings/prefooter',
        })
    },
    data: () => ({
        locale: localStorage.getItem('locale')
    }),
    mounted(){

        if(!['en','it'].includes(this.locale)){
          this.locale = 'en';
        }

    },
    methods:{
        async getSettigns(){
            await this.$store.dispatch('settings/getSettings')
        },
        translate(string){
            return this.$vuetify.locale.t(string)
        },
    }
}
</script>